require('./ctxDonut.style.scss');

const NO_DATA_SLICE_COLOR = "#e6e6e6";

class DonutController {
    constructor($scope, $element, $window) {
        this.$scope = $scope;
        this.$element = $element;
        this.$window = $window;
    }

    $onInit() {
        //Once data is set, ONLY then should the drawDonut function be triggered
        this.initialDataSetWatcher = this.$scope.$watch(() => this.data, (newVal, oldVal) => {
            if (!angular.isUndefined(newVal)) {
                this.drawDonut(this.data);
            }
        });
    }

    drawDonut() {
        let mainDonut, subDonut, color, subColor, width, height, data, subData, textLabel, textWidth, textHeight, padAngle, title;
        this.donutContent = this.$element.find(".donut-content");
        color = this.colors;
        subColor = this.subColors;
        width = this.donutContent.width();
        height = this.donutContent.height();
        data = this.formatData(this.data);
        subData = this.formatData(this.subData);
        textLabel = this.setTextLabel(data);
        title = this.customText ? data.reduce((sum, value) => sum + value) + ' ' + this.customText : textLabel;
        padAngle = this.padAngle ? this.padAngle : 0;

        this.radius = 50;
        this.subRadius = this.getSubDonutRadius(width, height);

        this.pie = this.$window.d3.layout.pie().padAngle(padAngle).sort(null);
        this.setArcFn(this.radius);
        if (this.subData) this.setArcFn(this.subRadius, true);

        this.svg = this.$window.d3.select(this.donutContent[0])
            .append("svg")
            .attr("width", '100%')
            .attr("height", '100%')
            .attr("viewBox", "0, 0, 100, 100")
            .attr("preserveAspectRatio", "xMidYMid meet")
            .classed("svg-content", true)
            .append("g")
            .attr("transform", "translate(50 ,50)");

        mainDonut = this.svg.append("g").attr("class", "firstClass");
        this.drawDonutPath(mainDonut, data, color);
        if (this.subData) {
            subDonut = this.svg.append("g").attr("class", "secondClass");
            this.drawDonutPath(subDonut, subData, subColor, true);
        }

        this.text = this.$window.d3.select(this.donutContent[0])
            .append("div")
            .attr("class", "donut-label-container")
            .style("width", () => {
                textWidth = width < height ? "80" : 100 * (height * 0.8) / width;
                return textWidth + "%";
            })
            .style("height", () => {
                textHeight = height < width ? "80" : 100 * (width * 0.8) / height;
                return textHeight + "%";
            })
            .style("left", () => 50 - textWidth / 2 + "%")
            .style("top", () => (this.customText ? 40 : 50) - textHeight / 2 + "%")
            .append("span")
            .attr("class", () => {
                return "donut-label-text" + (this.textColorClass ? ' ' + this.textColorClass : '');
            })
            .attr("title", title)
            .html(textLabel);

        let div = this.svg
            .append("div")
            .attr("class", "toolTip");

        //after initial data has been set and donut was drawn, set up a listener for changing data
        this.initialDataSetWatcher();
        this.$scope.$watch(() => this.data, () => {
            this.change(this.formatData(this.data), this.formatData(this.subData));
        });
        this.$scope.$watch(() => this.highlighted, (newValue, oldValue) => {
            this.onHighlightChange(newValue, oldValue);
        });
        this.$scope.$watch(() => this.subHighlighted, (newValue, oldValue) => {
            this.onHighlightChange(newValue, oldValue, true);
        });
    }

    drawDonutPath(element, data, color, isSubDonut) {
        let donutCtrl = this,
            tempColor = !data || !data.length || data.reduce((sum, value) => sum + value) === 0 ? NO_DATA_SLICE_COLOR : 'transparent';
        element.append("g").attr("class", "nullSlice")
            .append("path")
            .style("fill", tempColor)
            .attr("class", "slice")
            .attr("d", function () {
                let d = { data: 0, startAngle: 0, padAngle: 0, endAngle: Math.PI * 2, value: 0 };
                return donutCtrl[!isSubDonut ? 'arc' : 'arc2'](d);
            });
        element.append("g").attr("class", "slices");
        /* ------- PIE SLICES -------*/
        element.select(".slices").datum(2).selectAll("path.slice")
            .data(this.pie(data))
            .enter()
            .append("path")
            .style("fill", function (d, i) { return color && color.length > 0 ? color[i] : ''; })
            .attr("id", function (d, i) { return (!isSubDonut ? 'donutValue' : 'donutSubValue') + i; })
            .attr("class", "slice")
            .transition().duration(500)
            .attrTween("d", function (d) {
                this._current = this._current || d;
                let interpolate = donutCtrl.$window.d3.interpolate(this._current, d);
                this._current = interpolate(0);
                return (t) => donutCtrl[!isSubDonut ? 'arc' : 'arc2'](interpolate(t));
            });
    }

    getSubDonutRadius(width, height) {
        const diffBetweenDonut = 15;
        let temp = width >= height ? width : height,
            outerRadius = temp / 2,
            innerRadius = outerRadius * 0.9,
            donutWidth = outerRadius - innerRadius,
            tempRadius = (temp - 2 * donutWidth - diffBetweenDonut) / 2;

        return tempRadius * 50 / outerRadius;
    }

    setArcFn(radius, subDonut) {
        this[!subDonut ? 'arc' : 'arc2'] = this.$window.d3.svg.arc()
            .outerRadius(radius)
            .innerRadius(radius * 0.90)
            .cornerRadius(12);
        this[!subDonut ? 'highlightArc' : 'highlightArc2'] = this.$window.d3.svg.arc()
            .outerRadius(radius * 1.04)
            .innerRadius(radius * 0.90)
            .cornerRadius(12);
    }

    onHighlightChange(newValue, oldValue, subData) {
        if (!angular.isUndefined(newValue)) {
            this.highlightSlice(newValue, subData);
        } else {
            if (!angular.isUndefined(oldValue)) {
                this.resetHighlight(oldValue, subData);
            }
        }
    }

    highlightSlice(slice, subDonut) {
        let donutCtrl = this, tempEl;
        tempEl = !subDonut ? donutCtrl.svg.select(".firstClass") : donutCtrl.svg.select(".secondClass");
        tempEl.select(".slices").datum(2).selectAll("path.slice")
            .transition().duration(3000)
            .attrTween("d", function (d, i) {
                this._current = this._current || d;
                let interpolate = donutCtrl.$window.d3.interpolate(this._current, d);
                this._current = interpolate(0);
                if (slice === i) {
                    return (t) => donutCtrl[!subDonut ? "highlightArc" : "highlightArc2"](interpolate(t));
                } else {
                    return (t) => donutCtrl[!subDonut ? "arc" : "arc2"](interpolate(t));
                }
            });
    }

    resetHighlight(slice, subDonut) {
        let donutCtrl = this;
        let tempEl = !subDonut ? donutCtrl.svg.select(".firstClass") : donutCtrl.svg.select(".secondClass");
        tempEl.select(".slices").datum(2).selectAll("path.slice")
            .transition().duration(500)
            .attrTween("d", function (d, i) {
                this._current = this._current || d;
                let interpolate = donutCtrl.$window.d3.interpolate(this._current, d);
                this._current = interpolate(0);
                return (t) => donutCtrl[!subDonut ? "arc" : "arc2"](interpolate(t));
            });
    }

    formatData(data) {
        if (!data) return;
        this.total = data.length ? data.reduce((sum, value) => sum + value) : 0;
        return data;
    }

    change(data, subData) {
        let donutCtrl = this, mainDonutEl, subDonutEl,
            textLabel = this.setTextLabel(data),
            padAngle = this.setPadAngle(data),
            title = this.customText ? data.reduce((sum, value) => sum + value) + ' ' + this.customText : textLabel;

        donutCtrl.pie = this.$window.d3.layout.pie().padAngle(padAngle).sort(null);
        mainDonutEl = donutCtrl.svg.select(".firstClass");
        this.updateDonutValues(mainDonutEl, data);
        if (subData) {
            subDonutEl = donutCtrl.svg.select(".secondClass");
            this.updateDonutValues(subDonutEl, null, subData);
        }

        donutCtrl.text.attr("class", () => { return "donut-label-text" + (this.textColorClass ? ' ' + this.textColorClass : ''); })
            .attr("title", title)
            .html(textLabel);
    }

    updateDonutValues(donutElement, data, subData) {
        let donutCtrl = this;
        donutElement.select(".slices").datum(2).selectAll("path.slice")
            .data(donutCtrl.pie(!!data ? data : subData))
            .transition().duration(500)
            .attrTween("d", function (d) {
                this._current = this._current || d;
                let interpolate = donutCtrl.$window.d3.interpolate(this._current, d);
                this._current = interpolate(0);
                return (t) => donutCtrl[data ? 'arc' : 'arc2'](interpolate(t));
            });
        let tempData = data ? data : subData,
            color = !!subData || !tempData || !tempData.length || tempData.reduce((sum, value) => sum + value) === 0 ? NO_DATA_SLICE_COLOR : 'transparent';
        donutElement.select(".nullSlice").datum(2).selectAll("path.slice").style("fill", color);
    }

    setPadAngle(data) {
        return !this.padAngle || (data && data.filter((d) => d > 0).length === 1) ? 0 : this.padAngle;
    }

    setTextLabel(data) {
        let totalInUsed = Math.round(this.total - data[data.length - 1]);
        if (this.customText) {
            return '<b>' + data.reduce((sum, value) => sum + value) + '</b>' + '<br>' + '<span class="custom-text">' + this.customText + '</span>'
        } else {
            return (this.percentage ? (this.total ? (!this.percentageData ? Math.round(totalInUsed * 100 / this.total) : totalInUsed) + '%' : '0%') : this.total) || 0;
        }
    }
}

const donutComponent = {
    controller: DonutController,
    require: ['ngModel'],
    scope: {},
    template: require('./ctxDonut.template.html'),
    bindings: {
        data: '=?ngModel',
        colors: '<',
        percentage: '<?',
        percentageData: '<?',
        showTooltip: '@',
        highlighted: '<',
        subHighlighted: '<?',
        textColorClass: '<?',
        customText: '@?',
        padAngle: '<?',
        subData: '<?',
        subColors: '<?'
    }
};

DonutController.$inject = ['$scope', '$element', '$window'];

module.exports = donutComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxDonut/ctxDonut.component.js